import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  function handleLogout() { logout(); navigate('/login'); }

  // Close sidebar whenever the user navigates (mobile)
  React.useEffect(() => { setOpen(false); }, [location.pathname]);

  const navLinkClass = ({ isActive }) => 'nav-link' + (isActive ? ' active' : '');

  return (
    <div className="app-layout">
      <button className="mobile-menu-btn" onClick={() => setOpen(true)} aria-label="Open menu">
        <span /><span /><span />
      </button>
      {open && <div className="sidebar-overlay" onClick={() => setOpen(false)} />}
      <aside className={'sidebar' + (open ? ' open' : '')}>
        <div className="sidebar-logo">
          <img src="/logo.png" alt="AB Jewels" className="logo-img" />
          <button className="sidebar-close" onClick={() => setOpen(false)} aria-label="Close menu">&times;</button>
        </div>
        <nav className="sidebar-nav">
          <NavLink to="/" end className={navLinkClass}>Dashboard</NavLink>
          <NavLink to="/devices" className={navLinkClass}>Devices</NavLink>
          <NavLink to="/cctv" className={navLinkClass}>CCTV</NavLink>
          <NavLink to="/employees" className={navLinkClass}>Employees</NavLink>
          <NavLink to="/departments" className={navLinkClass}>Departments</NavLink>
          <NavLink to="/device-types" className={navLinkClass}>Device Types</NavLink>
          <NavLink to="/reports" className={navLinkClass}>Reports</NavLink>
          {user?.role === 'admin' && <>
            <NavLink to="/branches" className={navLinkClass}>Branches</NavLink>
            <NavLink to="/users" className={navLinkClass}>Users</NavLink>
            <NavLink to="/audit" className={navLinkClass}>Audit Log</NavLink>
          </>}
        </nav>
        <div className="sidebar-footer">
          <div className="user-chip">
            <span className="user-name">{user?.name}</span>
            <span className={`badge badge-role badge-${user?.role}`}>{user?.role}</span>
          </div>
          <button className="btn btn-ghost logout-btn" onClick={handleLogout}>Logout</button>
        </div>
      </aside>
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
